import styled, { css } from 'styled-components'
import { Props } from '~/shared/components/Progress'
import { COLORS } from '~/shared/constants/uiConstants'

const progressValueStyles = css`
  background-color: currentColor;
  transition: all 0.2s ease-out;
`

export const ProgressStyles = styled.progress<Props>`
  appearance: none;
  border: none;
  display: block;
  width: 100%;
  height: 100%;
  background: ${({ $background }) => $background || COLORS.WHITE};
  color: ${({ color }) => color || COLORS.PURPLE_400};

  &::-webkit-progress-bar {
    background: ${({ $background }) => $background || COLORS.WHITE};
  }

  &::-webkit-progress-value {
    ${progressValueStyles};
    transition: width 0.3s ease;
    background: ${({ color }) => color || COLORS.PURPLE_400};

    ${({ $valueBorderRadius }) =>
      $valueBorderRadius &&
      css`
        border-bottom-right-radius: ${$valueBorderRadius};
        border-top-right-radius: ${$valueBorderRadius};

        html[dir='rtl'] & {
          border-bottom-right-radius: 0;
          border-top-right-radius: 0;
          border-bottom-left-radius: ${$valueBorderRadius};
          border-top-left-radius: ${$valueBorderRadius};
        }
      `}
    ${({ $valueBorderRadius, $roundedAllSides }) =>
      $valueBorderRadius &&
      $roundedAllSides &&
      css`
        border-radius: 999px;
      `};
  }
  &::-moz-progress-bar {
    ${progressValueStyles}
  }
  &::-ms-fill {
    ${progressValueStyles}
  }
`
